/*
 * @Author: KellyYang
 * @Date: 2022-06-30 14:02:25
 * @LastEditors: KellyYang
 * @Description: 公司简介
 */
import React, { Fragment } from "react";
import { Timeline } from "antd";
import './index.less'

const CompanyIntroduction = () => {
  const ContactTitle = (<div className="contact-us-content-header-content">
    <span>锦誉征信</span>
    <span>CONTACT US</span>
  </div>)
  const milestoneTitle = (<div className="contact-us-content-header-content">
    <span>荣誉历程</span>
    <span>MILESTONE</span>
  </div>)
  const timeLineList = [
    {
      time: '2019.07',
      title: '锦誉征信服务（海南）有限公司成立'
    },
    {
      time: '2020.10',
      title: '系统获得“等保三级安全测评报告'
    },
    {
      time: '2020.12',
      title: '大数据平台上线'
    },
    {
      time: '2021.03',
      title: '人民银行总行同意备案'
    },
    {
      time: '2021.06',
      title: '首款产品落地3家银行'
    },
    {
      time: '2022.03',
      title: 'ISO9001信息安全管理体系认证'
    }
  ]
  return (
    <Fragment>
      <div className="company-introduction-container">
        <section>
          {ContactTitle}
          <div className="contact-content">
            <p>锦誉征信作为中国人民银行海口中心支行备案通过的企业征信机构，可合规地为金融机构提供基于大数据的企业征信服务。创始团队均曾在银行总行及头部互联网机构担任要职，在金融创新、风险管理、大数据运用领域具备丰富的实操经验和深刻的洞察理解。</p>
            <p>公司运用大数据、人工智能、知识图谱等技术，整合小微企业客户主体信用数据、商业信用数据、场景物联网数据，通过智能风控决策引擎，输出企业信用评分及风险等级，匹配高额度、低利率、长期限、好体验的贷款产品，提升融资便利，改善融资环境。 </p>
            <p>目前已同国内多家银行和非银机构达成合作，合作内容涵盖金融产品设计、风控数据报告、风控能力输出、数字化解决方案等各个领域，致力为金融机构提供一站式的端到端的行业解决方案，为中小微企业获得融资便利提供数字化服务。</p>
          </div>
        </section>
        <section>
          {milestoneTitle}
          <Timeline className="time-line-style" mode="left">
            {
              timeLineList.map((item, index) => {
                return (
                  <Timeline.Item key={index}>
                    <span>{item.time}</span>
                    <span>{item.title}</span>
                  </Timeline.Item>
                )
              })
            }
            <Timeline.Item className="last-time-line" color="transparent"></Timeline.Item>
          </Timeline>
        </section>
      </div>
    </Fragment>
  )
}
export default CompanyIntroduction;
